import {NumberOutlined, PercentageOutlined, PlayCircleOutlined} from '@ant-design/icons';
import {Tag} from 'antd';


export const BASE_PROJECTION_FIELDS = [
    'symbol', 'name', 'tags.sector', 'tags.industry', 'metrics.dy', 'metrics.pe_ttm', 'logo', 'metrics.mktcap',
    'exchange', 'stats.benchmarks.spy.corr_1_yr', 'stats.benchmarks.spy.upside', 'stats.benchmarks.spy.downside',
];

export const screenerMetrics = {
  book_value: { type: "number", min: 0, max: 1000, step: 10  },
  dy: { type: "percentage", min: 0, max: 10, step: 0.1},
  ebitda: { type: "currency", min: -100000000, max: 1000000000 },
  evr: { type: "number", min: 0, max: 50 },
  mktcap: { type: "currency", min: 0, max: 1000000000000 },
  operating_margin_ttm: { type: "percentage", min: -100, max: 100 },
  pe_fwd: { type: "number",  min: 0, max: 100 },
  pe_ttm: { type: "number",  min: 0, max: 100 },
  peg: { type: "number",  min: 0, max: 10 },
  price_book: { type: "number",  min: 0, max: 50 },
  price_sales: { type: "number",  min: 0, max: 50 },
  profit_margin: { type: "percentage",  min: -100, max: 100 },
  roa_ttm: { type: "percentage",  min: -100, max: 100 },
  short_ratio: { type: "number",  min: 0, max: 50 },
  short_percent: { type: "percentage",  min: 0, max: 100 },
  analyst_target: { type: "currency" },
  analyst_rating: { type: "number" }
};


export const screenerFieldToName = (field)=>{
    return {
        book_value: "Book Value",
        dy: "Divd Yield",
        ebitda: "EBITDA",
        evr: "EV/Revenue",
        mktcap: "Market Cap",
        operating_margin_ttm: "Op. Margin (TTM)",
        pe_fwd: "P/E (Fwd)",
        pe_ttm: "P/E (TTM)",
        peg: "PEG",
        price_book: "Price/Book",
        price_sales: "Price/Sales",
        profit_margin: "Profit Margin",
        roa_ttm: "ROA (TTM)",
        short_ratio: "Short Ratio",
        short_percent: "Short Percent",
        analyst_target: "Analyst Target",
        analyst_rating: "Analyst Rating"
    }[field]
}



const _handleGetScreenTypeColor = (type)=>{
    return {
        number: 'linear-gradient(#8845FF, #5D02FC)',
        currency: 'linear-gradient(#53F9E3, #00B59C)',
        percentage: 'linear-gradient(#5395F9, #5395F9)'
    }[type]
}

export const getScreenTypeColor = (name)=>{
    return _handleGetScreenTypeColor(screenerMetrics[name].type)
}



export const ScreenerTypeIcon = ({type})=>{
    const Icon = type === 'number' ? NumberOutlined : type === 'percentage' ? PercentageOutlined : PlayCircleOutlined;
    const color = _handleGetScreenTypeColor(type)
    return (
        <Tag style={{background: color}}>
            <Icon fontSize={'small'} className={'px-1'} bordered={false}  style={{color: "#FFF"}}/>
        </Tag>
    )

}